import styled from "styled-components"
import { Card } from '@ann/web-components';

export const StyledCard = styled(Card)`
    height: fit-content; 
    max-height: 100%;
    display: flex;
    flex-direction: column;
`

export const CardHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 2px;
	
	& > span:last-child {
		text-transform: capitalize;
	}
`;

export const ActionsContainer = styled.div`
  order: 3;
  align-self: flex-start;
		
	& > div > button {
		border: none;
	}
		
  & > div > button:hover {
     background-color: transparent;
     border: none;
     transition: none;
  }
`;

export const CardDescription = styled.div`
	color: ${(props)=> props.theme.colors.davysGrey };
	display: -webkit-box;
	display: -moz-box;
	-webkit-line-clamp: 2;
	-moz-line-clamp: 2;
	-webkit-box-orient: vertical;
	-moz-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.5;
	max-height: 3em;
`;

export const CardMeta = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`
export const CardMetaTagsContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 24px;
	flex-wrap: wrap;
`

export const CardMetaTags = styled.div`
	display: flex;
	flex-direction: row;
	gap: 4px;

  & > span:first-child{
     text-transform: capitalize !important;
  }
`

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 20px;
	border-radius: 8px;
	background: ${(props) => props.theme.colors.titanWhite};
`;

export const CardActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-top: auto;
`;

export const IconPreviewWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	width: 40px;
	height: 40px;
	border: 1px solid ${(props) => props.theme.colors.activeBlue};
	background-color: ${(props) => props.theme.colors.activeBlue};
	border-radius: 	8px;
	color: ${(props) => props.theme.colors.white};
`;